import { changeRequirementTabView } from './requirementTableViewSlice';
export default changeRequirementTabView;
